import { render, staticRenderFns } from "./AppActionIcon.vue?vue&type=template&id=c060ff50&scoped=true"
import script from "./AppActionIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppActionIcon.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AppActionIcon.vue?vue&type=style&index=0&id=c060ff50&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c060ff50",
  null
  
)

export default component.exports